// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', {isArray: require('./_is-array')});


// WEBPACK FOOTER //
// ./~/core-js/modules/es6.array.is-array.js